import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F8FAFC]">
        <Loader2 className="h-8 w-8 animate-spin text-[#232D4F]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.onboarding_required && !user.impersonator && location.pathname !== "/primeiro-acesso") {
    return <Navigate to="/primeiro-acesso" replace />;
  }
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : user.role === "instructor" ? "/prof" : "/app"} replace />;
  }
  return children;
}
